'use client'

import { Typography } from "@/shared/ui/atoms"
import Image from "next/image"
import Link from "next/link"
import { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment"
import { useLocale } from "next-intl"
import { useState } from "react"
import { Loading } from "@/shared/ui/organisms"
interface TreatmentCaseCardProps {
  item: TreatmentCaseSummaryResponse
  index: number
}

const TreatmentCaseCard = ({ item, index }: TreatmentCaseCardProps) => {
  const locale = useLocale()
  const { treatmentCaseId, treatmentSubjectName, title, thumbnail, hospitalOriginName, createdAt, hospitalThumbnailUrl } = item
  const [isLoading, setIsLoading] = useState(false)
  const afterClassName = 'after:content-[""] after:absolute after:top-0 after:left-0 after:w-full after:h-[1px] after:border-b border-gray-200 first:after:hidden'

  const handleCardClick = () => {
    setTimeout(() => {
      setIsLoading(true)
    }, 100)
  }

  return (
    <>
      <Link
        href={`/${locale}/treatment-case/${treatmentCaseId}`}
        className={`block relative py-4 ${afterClassName}`}
        onClick={handleCardClick}
      >
        <div className="flex gap-2 pb-[6px] justify-between items-center">
          <div>
            <Typography size={14} lineHeight={22} className="text-primary-500 font-medium">
              {treatmentSubjectName}
            </Typography>
            <Typography size={16} lineHeight={22} className="mt-1 text-gray-800 font-semibold line-clamp-2">
              {title}
            </Typography>
          </div>
          <div className="relative ml-2 flex items-center justify-center rounded-lg w-[80px] h-[80px] min-w-[80px] min-h-[80px] overflow-hidden bg-gray-100">
            <Image
              src={thumbnail.afterImageUrl ?? '/icons/logo.svg'}
              alt={title}
              fill
              sizes="80px"
              className="object-cover"
              priority={index === 0}
            />
          </div>
        </div>
        <div className="flex items-center">
          <span className="relative block h-6 w-6 shrink-0 overflow-hidden rounded-full bg-gray-100">
            <Image src={hospitalThumbnailUrl} alt="병원 로고" fill sizes="24px" className="object-cover" />
          </span>
          <Typography size={14} lineHeight={22} className="ml-[6px] text-gray-600 font-medium">{hospitalOriginName}</Typography>
          <span className="mx-1 w-[2px] h-[2px] bg-gray-400 rounded-full my-auto" />
          <Typography size={14} lineHeight={22} className="text-gray-400">{createdAt}</Typography>
        </div>
      </Link>
      {isLoading && <Loading />}
    </>
  )
}

export default TreatmentCaseCard